import { GenericService } from '../GenericService';
import { ServicePrice } from '../../ServicePrice';
import * as React from 'react';
import { IServiceComponentProps } from '../ServiceContainer/types';

export const StandardService = ({
  isSelected,
  formattedPrice,
  onClick,
  title,
  description,
  subtitle,
}: IServiceComponentProps) => {
  return (
    <GenericService
      title={title}
      subtitle={subtitle}
      description={description}
      dataName="StandardService"
      bgColor="white"
      onClick={onClick}
      checked={isSelected}
    >
      <ServicePrice price={formattedPrice} />
    </GenericService>
  );
};
